<script setup lang="ts">
import type { DirectSaleListingItemEntity } from '~/apiClient';

// PROPS
const { directSale } = defineProps({
    directSale: { type: Object as PropType<DirectSaleListingItemEntity>, required: true },
});

// COMPOSABLES
const { title } = useDirectSaleStatus(toRef(() => directSale));
</script>

<template>
    <p class="tracking-wide uppercase">{{ title }}</p>
</template>
